module.exports = {
        props:{
            app:true
        },
        data: function () {
            return {
                url:"",
                history:[],
                currentHistoryIndex:-1,
                src:""
            }
        },
        methods: {
            fixUrl:function () {
                if( !$.trim(this.url) ){
                    return;
                }
                if(!/^http[s]?:\/\//.test(this.url)){
                    this.url = "http://"+this.url
                }
            },
            go:function () {
                if(!$.trim(this.url))return;
                this.iframeGo(this.url);
            },
            iframeGo:function (url) {
                this.src = url;
            },
            iframeBack:function () {
                this.$els.iframe.contentWindow.history.go(-1);
            },
            iframeForward:function () {
                this.$els.iframe.contentWindow.history.go(1);
            },
            iframeReload:function () {
                this.$els.iframe.contentWindow.location.reload();
            }
        },
        components: {},
        ready: function () {
            if(this.app.data){
                this.url = this.app.data.index;
                this.fixUrl();
                this.go();
            }
        }
    }


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/apps/browser.vue
 ** module id = 71
 ** module chunks = 0
 **/